import { UserX, X } from "lucide-react";

export const AbsentBadge = ({ testId, removeTestId, onRemove }) => (
  <div data-testid={testId} className="mb-1.5 flex items-center gap-1.5 rounded-lg border border-dashed border-slate-300 bg-white/80 px-2 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-slate-500">
    <UserX className="h-3.5 w-3.5 shrink-0" />
    <span className="flex-1">Assente</span>
    <button type="button" data-testid={removeTestId} onClick={onRemove} className="flex h-6 items-center gap-0.5 rounded-md px-1.5 normal-case tracking-normal text-slate-600 hover:bg-slate-100" title="Rimuovi assenza">
      <X className="h-3 w-3" /> Rimuovi
    </button>
  </div>
);
